import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import { Button } from '../StyledComponents';
import { ApparelContext } from '../context/FlowContext';
const DesignStatus = ({
  nextStep,
  prevStep,
  currentStep,
  designNumbers,
  totalDesigns,
  isApparel = false,
}) => {
  const { totalSelectedDesignNums } = useContext(ApparelContext);

  const totalAllowed = isApparel ? 4 : totalDesigns;
  const totalSelected = isApparel
    ? totalSelectedDesignNums
    : designNumbers?.length;

  return (
    <StyledContainer
      className="status-bar"
      initial={{ right: -450 }}
      animate={{
        right: designNumbers?.length === 0 ? '-450px' : '0px',
      }}
    >
      <div className="row">
        <div className="current-status">
          <p>
            {totalSelected} of {totalAllowed} selected
          </p>
        </div>
        {!isApparel && (
          <Button onClick={prevStep} disabled={currentStep === 3}>
            Categories
          </Button>
        )}
        <Button onClick={nextStep} disabled={totalSelected < 1}>
          Next
        </Button>
      </div>
    </StyledContainer>
  );
};

const StyledContainer = styled(motion.div)`
  position: fixed;
  top: 170px;
  padding: 20px;
  background-color: #ffffffcc;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  box-shadow: 0px 0 5px 3px rgba(0, 0, 0, 0.25);

  @media (max-width: 767px) {
    padding: 8px;
    top: 450px;
    width: 75px;

    button {
      padding: 0.75rem 0;
      width: 100%;
      text-align: center;
      font-size: 0.8rem;
    }
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    @media (max-width: 767px) {
      flex-direction: column;
      gap: 8px;
    }
  }

  p {
    margin: 0.5rem;
    text-align: center;

    i {
      font-weight: 200;
    }
  }
`;

export default DesignStatus;
